import { useQueryHelper } from '@anytag/shared-hooks';
import { useYoutubeAnalyticsTrendPostByIdQuery } from '@anytag/graphql';
import { getYoutubePostUrl, getYoutubeVideoUrl } from '@anytag/shared-utils';
import { PostModal, usePostModalContext } from '../shared';

export interface TemplateProps {
  className?: string;
}

export const Template = ({ className }: TemplateProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { closeModal, selectedPostId } = usePostModalContext();
  const { data, loading } = useYoutubeAnalyticsTrendPostByIdQuery({
    skip: !selectedPostId,
    variables: { id: Number(selectedPostId) },
    onError: (err) => {
      closeModal?.();
      enqueueSnackbar(t(err.message), { variant: 'error' });
    }
  });

  const details = data?.youtubeAnalyticsTrendPostById;

  return (
    <PostModal.DetailsTemplate
      loading={loading}
      className={className}
      data={
        details
          ? {
              socialMedia: 'YOUTUBE',
              postDate: details?.postDate,
              caption: details?.videoCaption,
              postUrl: getYoutubePostUrl(details?.videoId),
              info: { name: details?.channel, avatar: details?.channelAvatar },
              video: { title: details?.videoTitle, url: getYoutubeVideoUrl(details?.videoId) },
              statistics: { likes: details?.likes, views: details?.views, comments: details?.comments }
            }
          : undefined
      }
    />
  );
};
